import AppConfig from '../AppConfig';
import Cookies from 'universal-cookie';
import md5 from "js-md5";
const cookies = new Cookies(null, { path: '/' });
export const baseUrl = AppConfig.serverUrl();

export const fetchOptions = (url, query, token = "", cacheMins = 0) => new Promise(async (resolve, reject) => {
    url = url + new URLSearchParams(query);
    let _cacheRet = cookies.get(md5(url));
    if (_cacheRet && cacheMins !== 0)
        return resolve(_cacheRet);
    console.log("get:", url, token, md5(url));
    fetch("http://oosa_rewild:6080/" + url, {
        method: 'OPTIONS',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        })
    })
        .then((response) => {
            console.log(response)
        })
        /* .then((ret) => {
            if (cacheMins !== 0)
            {
                cookies.set(md5(url), ret, { path: '/', maxAge: cacheMins * 60 });
            }
            resolve(ret)
        }) */
        .catch((error) => {
            console.error('Error:', error);
            reject(error);
        });
});


export const fetchGet = (url, query, token = "", cacheMins = 0) => new Promise(async (resolve, reject) => {
    url = url + new URLSearchParams(query);
    let _cacheRet = cookies.get(md5(url));
    if (_cacheRet && cacheMins !== 0)
        return resolve(_cacheRet);
    console.log("get:", url, token, md5(url));
    fetch(baseUrl + url, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        })
    })
        .then((response) => {
            if (response.status === 200) {
                response.json().then((ret) => {
                    if (cacheMins !== 0) {
                        cookies.set(md5(url), ret, { path: '/', maxAge: cacheMins * 60 });
                    }
                    resolve(ret)
                })
            }
            else {
                console.log(response)
                reject(response);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            reject(error);
        });
});

export const fetchPost = (path, body, token = "") => new Promise(async (resolve, reject) => {
    const header = {
        'accept': 'application/json',
        'Content-Type': 'application/json',
    };
    //console.log(baseUrl + url, body, JSON.stringify(body))
    fetch(baseUrl + path, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }),
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((ret) => {
            resolve(ret)
        })
        .catch((error) => {
            console.error('Error:', error);
            reject(error);
        });
});
export const fetchPostForm = (url, formData) => new Promise(async (resolve, reject) => {
    fetch(baseUrl + url, {
        method: 'POST',
        body: formData,
    })
        .then((response) => response.json())
        .then((ret) => {
            resolve(ret)
        })
        .catch((error) => {
            console.error('Error:', error);
            reject(error);
        });
});
export const countLinks = (str) => {
    const httpLinks = (str.match(/http:\/\//g) || []).length;
    const httpsLinks = (str.match(/https:\/\//g) || []).length;
    return httpLinks + httpsLinks;

}
/* 
"公車時刻表：https://ebus.gov.taipei/EBus/VsSimpleMap?routeid=0111000500&amp;gb=0請準時抵達"
@return <span>公車時刻表：</span><a href="https://ebus.gov.taipei/EBus/VsSimpleMap?routeid=0111000500&amp;gb=0" target="_blank">https://ebus.gov.taipei/EBus/VsSimpleMap?routeid=0111000500&amp;gb=0</a><span>請準時抵達</span>
 */
export const highlightLink = (str) => {
    // 使用提供的正则表达式匹配任意协议的 URL
    const urlRegex = /[A-Za-z]+:\/\/[A-Za-z0-9_\-\+~.:?&@=/%#,;{}\[\]\(\)\|\*\!\\]+/g;

    let parts = [];
    let lastIndex = 0;

    str.replace(urlRegex, (match, index) => {
        // 如果URL前有文字部分，先将文字部分推入parts数组
        if (lastIndex !== index) {
            parts.push({ type: 'txt', content: str.slice(lastIndex, index) });
        }
        // 将匹配到的URL推入parts数组
        parts.push({ type: 'url', content: match });
        // 更新lastIndex
        lastIndex = index + match.length;
    });
    // 如果最后一个匹配后的部分有剩余文字，将其推入parts数组
    if (lastIndex < str.length) {
        parts.push({ type: 'txt', content: str.slice(lastIndex) });
    }
    return parts;
}
// 格式化日期为字符串（YYYY/MM/DD）
export const formatDate = (date) => {
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).slice(-2);
    var day = ('0' + date.getDate()).slice(-2);
    return year + '/' + month + '/' + day;
}

export const isValidPhoneNumber = (phoneNumber) => {
    // 匹配美国和台湾的手机号码和市话号码，允许包含国码
    const regexUS = /^(\+?1?[0-9]{10}|\+[0-9]{1,4}-[0-9]{1,10})$/; // 匹配美国手机号码，可包含国家码 +1
    const regexTW = /^\+?886[0-9]{8,10}$/;        // 匹配台湾手机号码和市话号码，可包含国家码 +886
    // 使用正则表达式进行验证
    return regexUS.test(phoneNumber) || regexTW.test(phoneNumber);
}
export const isValidEmail = (email) => {
    // 使用正则表达式检查电子邮件地址格式
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // 返回正则表达式的测试结果
    return emailRegex.test(email);
}
export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const createCounterFn = (times, fn) => {
    let counter = 0;
    return () => {
        counter++;
        fn(counter, times);
    };
};
export const expandBounds = (bounds, scaleFactor) => {
    // 计算边界的高度和宽度
    const height = bounds.north - bounds.south;
    const width = bounds.east - bounds.west;

    // 计算扩展的边界
    const newHeight = height * scaleFactor;
    const newWidth = width * scaleFactor;

    // 计算新的边界点
    const north = bounds.north + (newHeight - height) / 2;
    const south = bounds.south - (newHeight - height) / 2;
    const east = bounds.east + (newWidth - width) / 2;
    const west = bounds.west - (newWidth - width) / 2;
    return {
        north: north,
        south: south,
        east: east,
        west: west
    };
};
export const stepZoom = (cluster, map) => {
    const markers = cluster.markers;
    const bounds = new window.google.maps.LatLngBounds();
    // 计算中心点位置
    let totalLat = 0;
    let totalLng = 0;
    markers.forEach(marker => {
        const position = marker.getPosition();
        totalLat += position.lat();
        totalLng += position.lng();
        bounds.extend(position);
    });
    const centerPosition = {
        lat: totalLat / markers.length,
        lng: totalLng / markers.length
    };
    map.panTo(centerPosition);
    const WORLD_DIM = { height: 256, width: 256 };
    const ZOOM_MAX = 21;

    const latRad = (lat) => {
        const sin = Math.sin(lat * Math.PI / 180);
        const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    };

    const zoom = (mapPx, worldPx, fraction) => Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);

    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    const lngDiff = ne.lng() - sw.lng();
    const lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    const latZoom = zoom(map.getDiv().offsetHeight, WORLD_DIM.height, latFraction);
    const lngZoom = zoom(map.getDiv().offsetWidth, WORLD_DIM.width, lngFraction);

    const targetZoom = Math.min(latZoom, lngZoom, ZOOM_MAX);

    const currentZoom = map.getZoom();
    const zoomSteps = 3;
    const zoomIntervals = [];

    if (currentZoom < targetZoom) {
        for (let i = currentZoom + zoomSteps; i < targetZoom; i += zoomSteps) {
            zoomIntervals.push(i);
        }
    } else {
        for (let i = currentZoom - zoomSteps; i > targetZoom; i -= zoomSteps) {
            zoomIntervals.push(i);
        }
    }
    zoomIntervals.push(targetZoom);

    zoomIntervals.forEach((zoom, index) => {
        setTimeout(() => {
            map.setZoom(zoom);
        }, index * 600);
    });
};

//  const stateMachine = createStateMachine("ready,rotate,move,reset,middle,other,laser");
export const createStateMachine = (validTransitions) => {
    let currentIndex = 0;
    return function checkStateTransition(nextState) {
        if (currentIndex >= validTransitions.length)
            return false;
        let validTransition = validTransitions[currentIndex];
        if (validTransition.endsWith(":"))
            validTransition = validTransition.slice(0, -1)
        let checkActions = [validTransition];
        if (currentIndex > 0) {
            let lastValidTransition = validTransitions[currentIndex - 1];
            if (lastValidTransition.endsWith(":")) {
                checkActions.push(lastValidTransition.slice(0, -1));
            }
        }
        if (checkActions.includes(nextState)) {
            if (validTransition === nextState)
                currentIndex++;
            return true;
        } else {
            return false;
        }
    };
}


// 将图片路径转换为ImageBitmap的函数
export const convertImagePathToImageBitmap = (imagePath) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = imagePath;
        img.onload = () => {
            createImageBitmap(img)
                .then(imageBitmap => resolve(imageBitmap))
                .catch(error => reject(error));
        };
        img.onerror = reject;
    });
}
export const getDistance = (lat1, lng1, lat2, lng2) => {
    const R = 6371; // 地球半徑 (公里)
    const toRad = (value) => (value * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // 回傳距離（公里）
};
export const createImageWithLabel = (imageBitmap, width, height, num, fontSize, fontColor, outWidth, outHeight) => {
    // 创建一个新的 canvas 元素
    const canvas = document.createElement('canvas');
    canvas.width = outWidth;
    canvas.height = outHeight;
    const ctx = canvas.getContext('2d');

    // 计算图片的中心位置
    const x = (outWidth - width) / 2;
    const y = (outHeight - height) / 2;

    // 在 canvas 上绘制图片
    ctx.drawImage(imageBitmap, x, y, width, height);

    // 设置字体大小和颜色
    ctx.font = `${fontSize}px Arial`;
    ctx.fillStyle = fontColor;

    // 在右上角绘制标签
    ctx.fillText(num, outWidth - ctx.measureText(num).width - 5, fontSize);

    // 将 canvas 转换为 Base64 格式
    const resultBase64Image = canvas.toDataURL();

    // 返回 Base64 格式的图片
    return resultBase64Image;
}
export const replaceColorWithTransparent = (canvas, targetColor) => {
    const context = canvas.getContext('2d');

    // 获取整个Canvas的像素数据
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const pixelData = imageData.data;

    // 将目标颜色替换为透明
    for (let i = 0; i < pixelData.length; i += 4) {
        const red = pixelData[i];
        const green = pixelData[i + 1];
        const blue = pixelData[i + 2];
        const alpha = pixelData[i + 3];

        // 判断当前像素的颜色是否与目标颜色匹配
        if (red === targetColor.red && green === targetColor.green && blue === targetColor.blue) {
            // 设置透明度为0
            pixelData[i + 3] = 0;
        }
    }

    // 将修改后的像素数据重新绘制到Canvas上
    context.putImageData(imageData, 0, 0);
}
export const cropImageFromCanvas = (ctx, color, isTransparent) => {
    var canvas = ctx.canvas,
        w = canvas.width, h = canvas.height,
        pix = { x: [], y: [] },
        imageData = ctx.getImageData(0, 0, canvas.width, canvas.height),
        x, y, index;

    for (y = 0; y < h; y++) {
        for (x = 0; x < w; x++) {
            index = (y * w + x) * 4;
            if (!(imageData.data[index] === color[0] && imageData.data[index + 1] === color[1] && imageData.data[index + 2] === color[2] && imageData.data[index + 3] === color[3])) {
                pix.x.push(x);
                pix.y.push(y);
            }
        }
    }
    pix.x.sort(function (a, b) { return a - b });
    pix.y.sort(function (a, b) { return a - b });
    var n = pix.x.length - 1;

    w = 1 + pix.x[n] - pix.x[0];
    h = 1 + pix.y[n] - pix.y[0];
    var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);
    if (isTransparent) {
        for (y = 0; y < h; y++) {
            for (x = 0; x < w; x++) {
                index = (y * w + x) * 4;
                if ((cut.data[index] === color[0] && cut.data[index + 1] === color[1] && cut.data[index + 2] === color[2] && cut.data[index + 3] === color[3])) {
                    cut.data[index + 3] = 0;
                }
            }
        }
    }


    canvas.width = w;
    canvas.height = h;
    console.log("w,h", w, h)
    ctx.putImageData(cut, 0, 0);
}

export const fixWhiteLine = (context, canvas) => {
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    const width = canvas.width;
    const height = canvas.height;

    const findAndFixLines = () => {
        const findX = [];
        const findY = [];
        const halfHeight = height * .2;
        const halfWidth = width * .2;
        const threshold = 20;
        // 遍历所有像素，寻找垂直和水平线
        for (let x = 1; x < width - 1; x++) {
            let verticalDiff = 0;
            for (let y = 0; y < height; y++) {
                const leftIndex = (y * width + (x - 1)) * 4; // 左边一格
                const index = (y * width + x) * 4;

                if (Math.abs(data[index] - data[leftIndex] > threshold) &&
                    Math.abs(data[index + 1] - data[leftIndex + 1] > threshold) &&
                    Math.abs(data[index + 2] - data[leftIndex + 2] > threshold)) {
                    verticalDiff++;
                }
            }
            if (verticalDiff > 200) {
                console.log("verticalDiff", verticalDiff, x)
            }
            if (verticalDiff > halfHeight) {
                console.log("verticalDiff", verticalDiff, halfHeight, x)
                findX.push(x);
            }
        }

        for (let y = 1; y < height - 1; y++) {
            let horizontalDiff = 0;
            for (let x = 0; x < width; x++) {
                const topIndex = ((y - 1) * width + x) * 4; // 上面一格
                const index = (y * width + x) * 4;
                if (Math.abs(data[index] - data[topIndex] > threshold) &&
                    Math.abs(data[index + 1] - data[topIndex + 1] > threshold) &&
                    Math.abs(data[index + 2] - data[topIndex + 2] > threshold)) {
                    horizontalDiff++;
                }
            }
            if (horizontalDiff > halfWidth) {
                findY.push(y);
            }
        }

        console.log("findX", findX);
        console.log("findY", findY);

        // 修复垂直线
        findX.forEach(x => {
            for (let y = 0; y < height; y++) {
                const leftIndex = (y * width + (x - 1)) * 4; // 左边一格
                const index = (y * width + x) * 4;
                data[index] = data[leftIndex];
                data[index + 1] = data[leftIndex + 1];
                data[index + 2] = data[leftIndex + 2];
                data[index + 3] = data[leftIndex + 3];
            }
        });

        // 修复水平线
        findY.forEach(y => {
            for (let x = 0; x < width; x++) {
                const topIndex = ((y - 1) * width + x) * 4; // 上面一格
                const index = (y * width + x) * 4;
                data[index] = data[topIndex];
                data[index + 1] = data[topIndex + 1];
                data[index + 2] = data[topIndex + 2];
                data[index + 3] = data[topIndex + 3];
            }
        });
    }

    findAndFixLines();
    return imageData;
}

export const generateRandomCoordinates = (center, radius) => {
    const getRandomCoordinate = (center, radius) => {
        const y0 = center.lat;
        const x0 = center.lng;
        const rd = radius / 111300; // 1 meter in degrees

        const u = Math.random();
        const v = Math.random();

        const w = rd * Math.sqrt(u);
        const t = 2 * Math.PI * v;
        const x = w * Math.cos(t);
        const y = w * Math.sin(t);

        const newLat = y + y0;
        const newLng = x + x0;

        return { position: { lat: newLat, lng: newLng } };
    };

    let coordinates = [];
    for (let i = 0; i < 2; i++) {
        coordinates.push(getRandomCoordinate(center, radius));
    }
    return coordinates;
};
export const validateAlbumURL = (url) => {
    const regexes = [
        /^https:\/\/(photos\.google\.com\/share|photos\.app\.goo\.gl)\/[a-zA-Z0-9_-]+$/,
        /^https:\/\/www\.icloud\.com\/sharedalbum\/[a-zA-Z0-9]+$/,
        /^https:\/\/(www\.flickr\.com\/photos\/[a-zA-Z0-9@]+\/albums\/[a-zA-Z0-9_-]+|flic\.kr\/s\/[a-zA-Z0-9]+)$/,
        /^https:\/\/mega\.nz\/folder\/[a-zA-Z0-9_-]+#[a-zA-Z0-9_-]+$/
    ];
    return regexes.some(regex => regex.test(url));
}
export const getCountyAndTownForAddr = (address_components) => {
    const newAddr=address_components.reverse().reduce((addr, v) => {
        if (v.types.includes("political")) {
            addr.push(v.long_name);
        }
        return addr;
    }, [])
    return newAddr;
}
export const getCountyAndTown = async (lat, lng) => {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const address = data.address;
        const county = address.county || address.city || '';
        const town = address.town || address.village || address.suburb || '';
        console.log("loc", data)
        return `${county}${town}`;
    } catch (error) {
        console.error('Error fetching the location data:', error);
        return null;
    }
}

export const geocodeLatLng = (geocoder, map, latlng, cb) => {
    geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK') {
            if (results[0]) {
                // 遍歷地理編碼結果以查找國家名稱
                let country;
                for (const component of results[0].address_components) {
                    if (component.types.includes('country')) {
                        country = component.long_name;
                        console.log("----", component)
                        break;
                    }
                }
                if (country) {
                    getGeocodingData(geocoder, country)
                        .then(data => {
                            map.setCenter(data.location);
                            map.fitBounds(data.viewport);
                            cb(country);
                        })
                        .catch(error => {
                            console.error('Error:', error);
                        });
                } else {
                    console.log('Country not found in the geocoding results');
                }
            } else {
                console.log('No results found');
            }
        } else {
            console.log('Geocoder failed due to: ' + status);
        }
    });
}

export const getGeocodingData = (geocoder, address) => {
    return new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, (results, status) => {
            if (status === 'OK') {
                const viewport = results[0].geometry.viewport;
                const extendedBounds = {
                    north: viewport.getNorthEast().lat(),
                    south: viewport.getSouthWest().lat(),
                    east: viewport.getNorthEast().lng(),
                    west: viewport.getSouthWest().lng()
                };
                resolve({
                    location: results[0].geometry.location,
                    viewport: extendedBounds
                });
            } else {
                console.log('Geocoding API is not enabled or there is an issue:', status);
                reject(new Error(`Geocoding API error: ${status}`));
            }
        });
    });
};
export const updateTimeWithHrMin = (date, hr, min) => {
    const updatedDate = new Date(date); // 創建日期的副本，以免修改原日期
    updatedDate.setHours(parseInt(hr, 10)); // 設置小時
    updatedDate.setMinutes(parseInt(min, 10)); // 設置分鐘
    updatedDate.setSeconds(0); // 重置秒
    updatedDate.setMilliseconds(0); // 重置毫秒
    return updatedDate;
}
export const loadJson = async (jsonFile) => {
    const path = jsonFile;
    const response = await fetch(path);
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    const jsonData = await response.json();
    return jsonData;
}
export const getAdministrativeArea = async (lat, lng, API_KEY, cb) => {
    const maxRetries = 3; // 最大重试次数
    let attempt = 0; // 当前尝试次数

    while (attempt < maxRetries) {
        try {
            attempt++;
            console.log(`Attempt ${attempt}`);

            const response = await fetch(
                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${API_KEY}`
            );
            const data = await response.json();
            const results = data.results;

            console.log("data", data);
            console.log("results", results);

            if (results.length > 0) {
                // 查找行政区域
                const administrativeAreas = {
                    level1: null,
                    level2: null,
                };

                results[0].address_components.forEach(component => {
                    if (component.types.includes('administrative_area_level_1')) {
                        administrativeAreas.level1 = component.long_name;
                    }
                    if (component.types.includes('administrative_area_level_2')) {
                        administrativeAreas.level2 = component.long_name;
                    }
                });

                if (administrativeAreas.level1 || administrativeAreas.level2) {
                    cb(administrativeAreas);
                    return; // 成功获取结果，退出函数
                } else {
                    cb('');
                    return; // 成功完成，但没有找到行政区域，退出函数
                }
            } else {
                if (attempt === maxRetries) {
                    cb('');
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            if (attempt === maxRetries) {
                cb('Error fetching data');
            }
        }
    }
};

export const addTextToImage = (imageSrc, elements) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';

        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(img, 0, 0);

            // 文字自動換行並對齊的函數
            function drawAlignedText(context, text, x, y, maxWidth, lineHeight, align, letterSpacing = 0) {
                const words = text.split('');
                let line = '';
                let yOffset = y;
                const lines = []; // 儲存每一行的文字

                for (let n = 0; n < words.length; n++) {
                    const testLine = line + words[n] + ' ';
                    const testWidth = context.measureText(testLine).width + letterSpacing * testLine.length;

                    if (testWidth > maxWidth && n > 0) {
                        lines.push(line); // 添加到行數組
                        line = words[n] + ' ';
                        yOffset += lineHeight;
                    } else {
                        line = testLine;
                    }
                }
                lines.push(line);

                // 繪製每一行文字，根據對齊方式計算 x 座標
                lines.forEach(line => {
                    let xPos = x;
                    if (align === 'center') {
                        const lineWidth = context.measureText(line).width + letterSpacing * line.length;
                        xPos = x - lineWidth / 2;
                    } else if (align === 'left') {
                        xPos = x;
                    }

                    // **逐個字繪製，手動加入字距**
                    for (let i = 0; i < line.length; i++) {
                        context.fillText(line[i], xPos, y);
                        xPos += context.measureText(line[i]).width + letterSpacing; // 加入字距
                    }

                    y += lineHeight;
                });
            }

            elements.forEach(element => {
                if (element.type === "text") {
                    ctx.font = `${element.fontWeight || "normal"} ${element.fontSize || 20}px ${element.fontFamily || 'Noto Sans TC'}`;
                    ctx.fillStyle = element.color || "black";
                    const lineHeight = (element.fontSize + 10) || 20;
                    if (element.text.length > element.maxLength)
                        element.text = element.text.substring(0, 25) + "...";
                    
                    // **支援 letterSpacing**
                    drawAlignedText(
                        ctx,
                        element.text || "",
                        element.x,
                        element.y,
                        element.maxWidth || 10000,
                        lineHeight,
                        element.align || 'center',
                        element.letterSpacing || -2 // 讓 user 可自訂字距
                    );
                } else if (element.type === "img") {
                    const subImg = new Image();
                    subImg.crossOrigin = 'anonymous';
                    subImg.onload = () => {
                        ctx.drawImage(subImg, element.x, element.y, element.width || subImg.width, element.height || subImg.height);
                    };
                    subImg.src = element.img;
                }
            });

            setTimeout(() => {
                const newImageSrc = canvas.toDataURL('image/png');
                resolve(newImageSrc);
            }, 100);
        };

        img.onerror = reject;
        img.src = imageSrc;
    });
}
